<template>
	<div class="review-progress">
		<table id="psjd-datatable" class="table table-hover table-bordered table-centered table-proApp">
			<thead>
				<tr>
					<th class="text-center">专家名称</th>
					<th class="text-center">手机/电话</th>
					<th class="text-center">所属评审组</th>
					<th class="text-center">应评数量</th>
					<th class="text-center">已评数量</th>
					<th class="text-center">剩余数量</th>
					<th class="text-center">是否提交评分</th>
					<th class="text-center">建议立项数</th>
					<th class="text-center">不建议立项数</th>
					<th class="text-center">操作</th>
				</tr>
			</thead>

			<tbody v-if="reviewProgressList.length">
				<tr v-for="(item, index) in reviewProgressList" :key="index">
					<td class="text-center">{{item.name}}</td>
					<td class="text-center">{{item.phone}}</td>
					<td class="text-center">{{item.groupName}}</td>
					<td class="text-center">{{item.toReviewDeclareNumber}}</td>
					<td class="text-center">{{item.hasReviewDeclareNumber}}</td>
					<td class="text-center">{{item.residueDeclareNumber}}</td>
					<td class="text-center">{{item.isSubmit==1?'已提交':'未提交'}}</td>
					<td class="text-center">{{item.proposalProjectNumber}}</td>
					<td class="text-center">{{item.notProposalProjectNumber}}</td>
					<td class="text-center"><el-button type="text" v-if="item.isSubmit==1" @click="cancleCommitScore(item.userId)">取消提交评分</el-button></td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
import { getReviewProgress, cancelScoringCriteria } from '@/api/after/expertReviewSettings.js';
export default {
	data() {
		return {
			reviewProgressList: [], //评审进度列表
			progressTotal: 0,
			progressParams: {
				id: 0,
				name: '',
				pageNumber: 1,
				pageSize: 100,
				regionId: 0
			}
		};
	},
	created() {
		this.getReviewProgress();
	},
	methods: {
		// 获取评审进度
		async getReviewProgress() {
			this.progressParams.id = this.$route.query.reviewId
			const res = await getReviewProgress(this.progressParams);
			if (res.code == 200) {
				console.log('评审进度',res);
				this.reviewProgressList = res.data.records;
				this.progressTotal = res.data.progressTotal;
			} else {
				this.$message.error(res.data);
			}
		},

		//取消评分
		cancleCommitScore(userId){
			// console.log(userId);
			let groupId = this.$route.query.reviewId;
      this.$confirm('确认取消提交评分？')
          .then(_ => {
            cancelScoringCriteria(userId, groupId).then((res)=>{
              if(200 == res.code){
                this.reviewProgressList.forEach((item, index)=>{
                  if(item.userId == userId){
                    this.reviewProgressList[index].isSubmit = 0;
                  }
                })
                this.$message.success('取消成功');
              }else{
                this.$message.error('取消失败');
              }
            }).catch((err)=>{
              this.$message.error('取消失败');
            })
          })
          .catch(_ => { });
		},
	}
};
</script>

<style scoped></style>
